import React from 'react'
import { useRoutes } from 'react-router-dom'
import { RequireAuth } from '../../components/RequireAuth/RequireAuth'
import { ROUTES } from '../../constants/routes'
import { ErrorPage } from '../ErrorPage/ErrorPage'
import { NotFound } from '../NotFound/NotFound'
import { AcceptInvitePage } from './pages/AcceptInvite/AcceptInvite'
import { Dashboard } from './pages/Dashboard/Dashboard'
import { ForgotPassword } from './pages/ForgotPassword/ForgotPassword'
import { LoginPage } from './pages/Login/Login'
import { Logout } from './pages/Logout/Logout'
import { ProgramImport } from './pages/ProgramImport/ProgramImport'
import { RecoverPassword } from './pages/RecoverPassword/RecoverPassword'
import { SetupProgram } from './pages/SetupProgram/SetupProgram'
import { Signup } from './pages/Signup/Signup'
import { WhatsNewDetails } from './pages/WhatsNewDetails/WhatsNewDetails'

export const DashboardRoutes = () => {
  const element = useRoutes([
    {
      path: ROUTES.SETUP,
      element: (
        <RequireAuth isProtected={true}>
          <SetupProgram />
        </RequireAuth>
      ),
    },
    {
      path: ROUTES.DASHBOARD,
      element: (
        <RequireAuth isProtected={true}>
          <Dashboard />
        </RequireAuth>
      ),
    },
    {
      path: ROUTES.WHATS_NEW,
      element: (
        <RequireAuth isProtected={true}>
          <WhatsNewDetails />
        </RequireAuth>
      ),
    },
    {
      path: ROUTES.WHATS_NEW_DETAILS,
      element: (
        <RequireAuth isProtected={true}>
          <WhatsNewDetails />
        </RequireAuth>
      ),
    },
    {
      path: ROUTES.IMPORT,
      element: (
        <RequireAuth isProtected={true}>
          <ProgramImport />
        </RequireAuth>
      ),
    },
    { path: ROUTES.LOGIN, element: <LoginPage /> },
    { path: ROUTES.SIGNUP, element: <Signup /> },
    { path: ROUTES.LOGOUT, element: <Logout /> },
    { path: ROUTES.FORGOT_PASSWORD, element: <ForgotPassword /> },
    { path: ROUTES.RECOVER_PASSWORD, element: <RecoverPassword /> },
    { path: ROUTES.ACCEPT_INVITE, element: <AcceptInvitePage /> },
    { path: ROUTES.ERROR, element: <ErrorPage /> },
    {
      path: '*',
      element: <NotFound />,
    },
  ])
  return element
}
